import { Box } from "@mui/material";
import { Relationship, YesOrNoFlug } from "../../assets/data/Constants";
import { labelids } from "../../assets/data/TkExplanationProperty";
import TkBorder from "../../components/atoms/TkBorder";
import { ITkFakeTableLineProps } from "../../type/componentsType/TkFakeTableLine";
import { TkGetCodeList } from "../../utils/TkGetCode";

const splitTextAtPeriods = (
  text: string,
  rule: string | undefined
): string[] => {
  if (!text || !rule) return [text];

  const sentences = text.split(rule);
  return sentences;
};

const stepper = [
  "連絡先の登録",
  "退職者との続柄の確認",
  "証明書類の添付",
  "機構へ連絡",
  "請求者の登録",
  "振込先金融機関の登録",
  "添付書類の登録",
  "本人確認の書類の添付",
  "登録内容の確認",
  "機構へ提出",
];

const fakeTableList: ITkFakeTableLineProps[] = [
  {
    title: "退職者名",
    keyword: "retireeName",
    requiredIcon: true,
    type: "text",
    showLine: false,
  },
  {
    title: "請求者氏名（ｶﾅ）",
    keyword: "demanderNameKana",
    type: "text",
  },
  {
    title: "請求者氏名",
    keyword: "demanderName",
    type: "text",
  },
  {
    title: "請求者現住所（郵便番号）",
    keyword: "demanderZipcode",
    type: "text",
  },
  {
    title: "請求者現住所（郵便番号以外）",
    keyword: "address",
    type: "locationGroup",
  },
  {
    title: "請求者連絡先",
    keyword: "tel",
    type: "text",
  },
  {
    title: "メールアドレス",
    keyword: "demanderEmail",
    type: "text",
  },
  {
    title: "続柄",
    keyword: "demanderRelationship",
    type: "radio",
    radioPropsList: TkGetCodeList(Relationship),
    disabled: true,
  },
  {
    title: "その他",
    keyword: "demanderRelationshipOthers",
    type: "text",
    showLine: false,
  },
  {
    title: "退職者からの生計維持の有無",
    keyword: "livelihoodFromRetireeFlg",
    type: "radio",
    disabled: true,
    radioPropsList: TkGetCodeList(YesOrNoFlug),
  },
  {
    title: "あなたと同順位の請求権保持者の有無",
    keyword: "demanderFlg",
    type: "radio",
    disabled: true,
    radioPropsList: TkGetCodeList(YesOrNoFlug),
  },
  {
    title: "①「死亡診断書」又は「死体検案書」（写）",
    keyword: "deathCertificate",
    type: "downloadLink",
    showLine: false,
    isButton: false,
    downloadBase64: true,
  },
  {
    title:
      "②職員の死亡当時、主として職員の収入により生計を維持していた親族がいることを証する「生計維持に関する調査書」（様式１１号）",
    keyword: "livelihoodSupportRelatives",
    type: "downloadLink",
    showLine: false,
    isButton: false,
    downloadBase64: true,
  },
  {
    title:
      "②職員の死亡当時、主として職員の収入により生計を維持していた親族がいないことを証する「生計維持に関する調査書」（様式１１号）",
    keyword: "livelihoodNoSupportRelatives",
    type: "downloadLink",
    showLine: false,
    isButton: false,
    downloadBase64: true,
  },
  {
    title: "④内縁関係についての「生計維持に関する調査書」（様式１１号）",
    keyword: "livelihoodSupportWithoutFormalMarriage",
    type: "downloadLink",
    showLine: false,
    isButton: false,
    downloadBase64: true,
  },
  {
    title: "④職員の死亡当時の世帯員の状況を明らかにできる「住民票の謄本」",
    keyword: "certificateOfResidence",
    type: "downloadLink",
    showLine: false,
    isButton: false,
    downloadBase64: true,
  },
  {
    title: "⑥その他、事実上の配偶者であることを証明する書類",
    keyword: "lawfulPartner",
    type: "downloadLink",
    showLine: false,
    isButton: false,
    downloadBase64: true,
  },
  {
    keyword: "textDocument",
    type: "lineTitle",
    lineTitle: (
      <>
        {labelids.labelid.LBLR410022_02}
        <br />
        <TkBorder>
          {splitTextAtPeriods(labelids.labelid.LBLR410022_03, "\\n").map(
            (item, index) => {
              return (
                <Box key={index} className="tkInfoText">
                  {item}
                </Box>
              );
            }
          )}
        </TkBorder>
      </>
    ),
  },
];

const schema: any = {};

export { stepper, fakeTableList, schema, splitTextAtPeriods };
